import { __rest, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Card } from '../../base/card/Card.js';
import { PaymentMethod } from '../paymentMethod/PaymentMethod.js';
import styles from './PaymentMethodCard.module.scss.js';
import { Skeleton } from './skeleton/Skeleton.js';

var PaymentMethodCard = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, props = __rest(_a, ["children", "className", "style"]);
    return (jsxs(Card, __assign({ className: clsx(className, styles.paymentMethodCard), style: style }, { children: [jsx(PaymentMethod, __assign({}, props)), children] })));
};
PaymentMethodCard.Skeleton = Skeleton;

export { PaymentMethodCard };
